import { useState } from "react";
import "react-tooltip/dist/react-tooltip.css";

import { Icon } from "../../assets/icons/Icon";
import Button from "../ui/button/Button";
import styles from "./JavaScriptSnippet.module.scss";

// Make sure to import the CSS

interface JavaScriptSnippetProps {
  code: string;
  actions?: React.ReactNode;
}

const JavaScriptSnippet = ({ code, actions }: JavaScriptSnippetProps) => {
  const [copyButtonTxt, setCopyButtonTxt] = useState("Copy");
  const copyToClipboard = (text: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopyButtonTxt("Copied!");
        setTimeout(function () {
          setCopyButtonTxt("Copy");
        }, 3000);
      })
      .catch((err) => {
        console.error(err.message);
      });
  };

  return (
    <div className={styles.snippetContainer}>
      <div className={styles.snippetHeader}>
        <div className={styles.snippetHeaderTitle}>JavaScript Snippet</div>
        <div className={styles.actionButtons}>
          {actions}

          <Button outlined onClick={() => copyToClipboard(code)}>
            <span className={styles.buttonText}>
              {copyButtonTxt} <Icon iconName="CopyIcon" />
            </span>
          </Button>
        </div>
      </div>
      <div className={styles.snippetCodeSection}>
        <div className={styles.snippetCode}>{code}</div>
      </div>
    </div>
  );
};

export default JavaScriptSnippet;
